import React, { useState, useEffect,useRef } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Button, Col, Container, Form, Row, InputGroup } from "react-bootstrap";
import { getActiveChains,getFormDetailsById} from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate,useParams } from "react-router-dom";
import config from "../../config";
import { ApproveToken,ApproveUsdtToken,NewPool2 } from "../../Web3/Liquidity/swapConnector"
import { UsdtEarned,TransferUsdt } from "../../Web3/Connector";
import Web3WalletProvider from '../../ConnectWallet/walletProvider'
import { useDisconnect, useAccount } from "wagmi";
import { hideLoader, showLoader } from "../loader";
import {submitPreLiquidityApplicationForm} from '../../Action/action'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineDateRange } from "react-icons/md";

export default function PreSaleSwap() {
  const {id} = useParams()

  const [form, setForm] = useState([]);


  const [liqForm, setLiqForm] = useState({
    liquidityValue: "",
    minLiq:"",
    startDateAndTime:"",
    tokenPrice: "",
    agree: false,
  });
  
  const [update, setUpdate] = useState(false);

  const [errors, setErrors] = useState({});
  const [chainOptions, setChainOptions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);

  const [getRpc, setRpc] = useState();
  const navigate = useNavigate();

  let _useWeb3WalletProvider = Web3WalletProvider()
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [presaleLoading, setPresaleLoading] = useState(false)
  const {address, isConnected} = useAccount()
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const percentage = [60,65,75,80,85,90,95,100]
  const [percent, setPercent] = useState(60)
  const [usdtNewState, setUsdtNewState] = useState(0);
  const [tokenPriceSwap, setTokenPriceSwap] = useState(0)
  const [chainId, setChainId] = useState('')





useEffect(() => {
  if(!isProviderLoaded) {_useWeb3WalletProvider.then((data) => {
    if(data) {
      setisProviderLoaded(true)
    }
  })}
},[])
const buttonRef = useRef(null); // Add a ref for the button

useEffect(() => {
  // AutoBNBally click the button after 2 seconds
  const timer = setTimeout(() => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  }, 2000);

  return () => clearTimeout(timer); // Cleanup the timer
}, []);


  useEffect(() => {
    getChains();
    getFormData()
  }, []);


  
    const handlePercentChange = (e) => {
      let value = parseInt(e.target.value)
      setPercent(value)
    }
  

  const getChains = async () => {
    try {
      const response = await getActiveChains();
      if (response.success) {
        setChainOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const getFormData = async () => {
    try {
      const response = await getFormDetailsById({id});
      console.log('Liquid1',response)
      if (response.success) {
        let usdtE = await usdtEarnings(response.data[0])
        //console.log('xxoxoxo',usdtE)
        response.data[0].usdtNew = usdtE
        setUsdtNewState(usdtE)
        setForm(response.data);
        setLiqForm((prevForm) => ({
            ...prevForm,
            minLiq: (usdtE * percent) / 100
          }))
        }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if(usdtNewState) {
      setLiqForm((prevForm) => ({
        ...prevForm,
        minLiq: (usdtNewState * percent) /100
      }))
    }
  },[percent])


  const usdtEarnings = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress:formData.token_address,
        preSaleAddress:formData.presaleContract,
        networkId:formData.chainNetworkId
      }
      //console.log('us req',request)
        let bal = await UsdtEarned(request)
       //console.log('UUUUUU',bal)
        return bal.usdtAmount
    } catch (error) {
        console.log(error)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "chainName") {
      for (let i = 0; i < chainOptions.length; i++) {
        if (chainOptions[i].id == value) {
          setRpc(chainOptions[i].chainRPCUrl);
          setChainId(chainOptions[i].chainNetworkId)
        }
      }
    }

    if (name === "liquidityValue") {
      let price = liqForm.minLiq / value
      if(chainId === '0x38') {
        price =  Math.floor(price * 1e18) / 1e18;
      } else {
        price = Math.floor(price * 1e6) / 1e6;
       }
      setTokenPriceSwap(price)
    }

    const index = 0
    setForm(prevForm => {
      const newForm = [...prevForm];
      newForm[index] = { ...newForm[index], [name]: value };
      return newForm;
    });

    setLiqForm(prev => ({ ...prev, [name]: value }));
  };

const now = new Date();
const minSelectableTime = new Date();
minSelectableTime.setMinutes(minSelectableTime.getMinutes() + 15);
  const handleFileChange = (e) => {

    const index = 0
    //console.log(e.target.files[0])
    setForm(prevForm => {
      const newForm = [...prevForm];
      newForm[index] = { ...newForm[index], brand_logo: e.target.files[0]};
      return newForm;
    });
    setImagePreview(URL.createObjectURL(e.target.files[0]));
  };


  const handleCheckboxChange = (e) => {
    setLiqForm({
      ...liqForm,
      agree: e.target.checked,
    });
  };



  const validateForm = async () => {
    const newErrors = {};
    const isInvalidNumber = (value) => isNaN(value) || value === '' || value <= 0;
    const requiredFields = [
      "liquidityValue"
    ];

   if (!liqForm.startDateAndTime) {
    newErrors.startDateAndTime = "Select a start date and time";
  }

  if(tokenPriceSwap < form[0].usdt_price) {
      newErrors.tokenPrice = "Token Price cannot be less than presale price "
    }
  

    requiredFields.forEach((field) => {
        if (["liquidityValue"].includes(
          field
        ) &&
        isInvalidNumber(liqForm[field])
      ) {
        newErrors[field] = `${field} must be a valid positive number`;
      }
    });
    if (!liqForm.agree) {
      newErrors.agree = "You must agree to the terms";
    }


    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  

//   const handleSubmitPool = async (e) => {
//     e.preventDefault();
//    let ver = await validateForm()
// if(!ver) {
//   toast.error("Please check the validations required.");
//   return
// }
//     if(!isConnected) {
//       toast.error("Please connect your wallet");
//       setconnectWalletNow(true)
//       return
//     }
//     showLoader()
//     try {

//     let request = {
//       walletProvider:  _useWeb3WalletProvider,
//       tokenOwner: address,
//       tokenAddress:form[0].token_address,
//       tokenAmount:liqForm.liquidityValue,
//       usdtAmount: liqForm.minLiq,
//       pairContractAddress:form[0].pairContractAddress,
//       preSaleAddress: form[0].presaleContract,
//       usdtAddress:form[0].usdtContract,
//       startDateAndTime: liqForm.startDateAndTime,
//       networkId:form[0].chainNetworkId
//     }
//     console.log('5',request)
//      let transfer = await TransferUsdt(request)
//     if (transfer.status) {
//       let tokenApproval = await ApproveToken(request)
//     if (tokenApproval.status) {
//       let usdtApproval = await ApproveUsdtToken(request)
//         if (usdtApproval.status) {
//       let res = await NewPool2(request)
//      if (res.status) {
//         toast.success (res.message)
//         setPresaleLoading(false)
//         let data = {
//           owner_address: form[0].owner_address,
//           tokenName:form[0].token_name,
//           tokenSymbol: form[0].token_symbol,
//           tokenAddress: form[0].token_address,
//           chainNetwork: form[0].chain,
//           description: form[0].description,
//           brand_logo: form[0].brand_logo,
//           startDateAndTime: liqForm.startDateAndTime,
//           kyc: form[0].kyc,
//           audit: form[0].audit,
//           website: form[0].website,
//           liquidityValue: liqForm.liquidityValue,
//           usdtAmount: liqForm.minLiq,
//           whitepaper: form[0].whitepaper,
//           socialAccount: form[0].social_accounts
//         }
//         let submit = await submitPreLiquidityApplicationForm(data)
//         if(submit.success) {
//         navigate(`${config.baseUrl}launchpad`, {replace: true})
//         window.scrollTo(0,0)
//         } else {
//           toast.error(submit.message)
//           console.log('Error saving in db')
//         }
//        } else {
//        toast.error(res.message)
//          setPresaleLoading(false)
//        }
//      } else {
//        toast.error(usdtApproval.message)
//        console.log('USDT approval error',usdtApproval.message)
//      } 
//    }
//      else {
//        toast.error(tokenApproval.message)
//         console.log('Token approval error',tokenApproval.message)
//      }
//     }
//      else {
//        toast.error(transfer.message)
//        console.log('Token transfer error',transfer.message)
//    }    
// } catch (error) {
//   console.log('Error Pool',error)
//   toast.error('Presale Pool',error)
// } finally {
//   hideLoader()
// }
// }

const handleSubmitPool = async (e) => {
  e.preventDefault();

  const ver = await validateForm();
  if (!ver) {
    toast.error("Please check the validations required.");
    return;
  }

  if (!isConnected) {
    toast.error("Please connect your wallet");
    setconnectWalletNow(true);
    return;
  }

  showLoader();

  try {
    const request = {
      walletProvider: _useWeb3WalletProvider,
      tokenOwner: address,
      tokenAddress: form[0].token_address,
      tokenAmount: liqForm.liquidityValue,
      usdtAmount: liqForm.minLiq,
      pairContractAddress: form[0].pairContractAddress,
      preSaleAddress: form[0].presaleContract,
      usdtAddress: form[0].usdtContract,
      startDateAndTime: liqForm.startDateAndTime,
      networkId: form[0].chainNetworkId
    };

    console.log('Pool Submit Request:', request);

    // Step 1: USDT Transfer
    const transfer = await TransferUsdt(request);
    if (!transfer.status) {
      toast.error(transfer.message || "USDT Transfer failed");
      console.log('Transfer error:', transfer.message);
      return;
    }

    // Step 2: Token Approval
    const tokenApproval = await ApproveToken(request);
    if (!tokenApproval.status) {
      toast.error(tokenApproval.message || "Token approval failed");
      console.log('Token approval error:', tokenApproval.message);
      return;
    }
    if (!tokenApproval.alreadyApproved) {
      toast.success("Token approved successfully");
    }

    // Step 3: USDT Approval
    const usdtApproval = await ApproveUsdtToken(request);
    if (!usdtApproval.status) {
      toast.error(usdtApproval.message || "USDT approval failed");
      console.log('USDT approval error:', usdtApproval.message);
      return;
    }
    if (!usdtApproval.alreadyApproved) {
      toast.success("USDT approved successfully");
    }

    // Step 4: Create Pool
    const res = await NewPool2(request);
    if (!res.status) {
      toast.error(res.message || "Pool creation failed");
      setPresaleLoading(false);
      return;
    }

    toast.success(res.message || "Pool created successfully");
    setPresaleLoading(false);

    // Step 5: Save Metadata
    const data = {
      owner_address: form[0].owner_address,
      tokenName: form[0].token_name,
      tokenSymbol: form[0].token_symbol,
      tokenAddress: form[0].token_address,
      chainNetwork: form[0].chain,
      description: form[0].description,
      brand_logo: form[0].brand_logo,
      startDateAndTime: liqForm.startDateAndTime,
      kyc: form[0].kyc,
      audit: form[0].audit,
      website: form[0].website,
      liquidityValue: liqForm.liquidityValue,
      usdtAmount: liqForm.minLiq,
      whitepaper: form[0].whitepaper,
      socialAccount: form[0].social_accounts
    };

    const submit = await submitPreLiquidityApplicationForm(data);
    if (submit.success) {
      navigate(`${config.baseUrl}launchpad`, { replace: true });
      window.scrollTo(0, 0);
    } else {
      toast.error(submit.message || "Failed to save pool data");
      console.log('Error saving in DB');
    }

  } catch (error) {
    console.error('Error in Pool Submission:', error);
    toast.error("Something went wrong during pool submission");
  } finally {
    hideLoader();
  }
};

  return (
    <>
      <Toaster />
      <Header />
      <section className="process_form">
        <Container>
       
         {form.length > 0 && <Form >
            <div className="from_box my-5">
              <h2>The Launch process:</h2>
              <p>
                Must be confirmed with the Owner wallet (the tokens will be
                transferred to the INFI CDEX Launchpool)
              </p>
              <Row className="mt-4">
                <Col lg={6}>
                  <Form.Label>Token Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="token_name"
                    value={form[0].token_name}
                    onChange={handleInputChange}
                    isInvalid={!!errors.token_name}
                    disabled={!update?true:false}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.token_name}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6}>
                  <Form.Label>Token Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="token_address"
                    value={form[0].token_address}
                    onChange={handleInputChange}
                    isInvalid={!!errors.token_address}
                    disabled={!update?true:false}

                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.token_address}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6}>
                  <Form.Label>Token Symbol</Form.Label>
                  <Form.Control
                    type="text"
                    name="token_symbol"
                    value={form[0].token_symbol}
                    onChange={handleInputChange}
                    isInvalid={!!errors.token_symbol}
                    disabled={!update?true:false}

                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.token_symbol}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6}>
                  <Form.Label>Chain Network</Form.Label>
                  <Form.Control
                    as="select"
                    name="chainName"
                    value={form[0].chainName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.chainName}
                    disabled={!update?true:false}

                  >
                    {chainOptions.map((option, index) => (
                      <option key={index} value={option.chainName}>
                        {option.chainName}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.chainName}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mt-4">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    placeholder="max 1000 characters"
                    value={form[0].description}
                    onChange={handleInputChange}
                    isInvalid={!!errors.description}
                    disabled={!update?true:false}

                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Col>

                {update?<Col lg={12} className="mt-4">
                  <Form.Label>ADD a Brand Logo/Upload a Logo</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type="file"
                      className="custom_dragdrop_form"
                      onChange={handleFileChange}
                      isInvalid={!!errors.brand_logo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.brand_logo}
                    </Form.Control.Feedback>
                    <div className="custom_dragdrop my-3">
                      <span>
                        Click to upload files, or drag & drop files here
                      </span>
                    </div>
                    {imagePreview && (
                      <div className="image-preview mt-3">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ maxHeight: "200px", maxWidth: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>:
                <Col lg={12} className="mt-4">
                <Form.Label className="me-2">Brand Logo</Form.Label>
               
                  
                      <img
                        src={`${config.imagePath}${form[0].brand_logo}`}
                        alt=""
                        style={{ maxHeight: "200px", maxWidth: "100%" }}
                      />
               
              </Col>}

                <Col lg={6} className="mt-4">
                  <Form.Label>KYC</Form.Label>
                  <Form.Control
                    type="text"
                    name="kyc"
                    value={form[0].kyc}
                    onChange={handleInputChange}
                    isInvalid={!!errors.kyc}
                    disabled={!update?true:false}

                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.kyc}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>Audit</Form.Label>
                  <Form.Control
                    type="text"
                    name="audit"
                    value={form[0].audit}
                    onChange={handleInputChange}
                    isInvalid={!!errors.audit}
                    disabled={!update?true:false}

                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.audit}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col lg={6} className="mb-4">
                  <Form.Label>Sale Start Date & Time *</Form.Label>
                  <div className="datetime position-relative">
                    <DatePicker
                    selected={liqForm.startDateAndTime}
                    onChange={(date) => handleInputChange({ target: { name: "startDateAndTime", value: date } })}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="dd/MM/yyyy h:mm aa"
                    minDate={now}
                    minTime={liqForm.startDateAndTime && liqForm.startDateAndTime.toDateString() === now.toDateString() ? minSelectableTime : new Date(0, 0, 0, 0, 0)} 
                    maxTime={new Date(0, 0, 0, 23, 45)} 
                    customInput={
                      <Form.Control
                        isInvalid={!!errors.startDateAndTime}
                        placeholder="Select date & Time"
                      />
                    }
                  />
                  <span className="position-absolute end-0 top-0 bottom-0 d-flex h-100 align-items-center pe-2"><MdOutlineDateRange/></span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.startDateAndTime}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mt-4">
                <h5>Tokenomics</h5> </Row>

                <Col lg={6} className="mt-4">
                  <Form.Label>Presale Price</Form.Label>
                  <Form.Control
                    type="number"
                    name="price"
                    value={chainId === "0x38" ? Math.floor((form[0].usdt_price) * 1e18) / 1e18 : Math.floor((form[0].usdt_price) * 1e6) / 1e6}
                    disabled
                  />
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>USDT Liquidity Available</Form.Label>
                  <Form.Control
                    type="number"
                    name="usdtNew"
                    placeholder="Value"
                    value={form[0].usdtNew}
                    onChange={handleInputChange}
                    disabled={!update?true:false}
                    isInvalid={!!errors.usdt_amount}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.usdt_amount}
                  </Form.Control.Feedback>
                </Col>
                <Col lg={6} className="mt-4">
                </Col>

                <Col lg={6}>
                <Form.Label>USDT Liquidity To Send To Pool</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control aria-label="Text input with dropdown button"
                    type="number"
                    name="minLiq"
                    placeholder="Minimum USDT required to list on CDEX"
                    value={liqForm.minLiq}
                    isInvalid={!!errors.minLiq}
                    disabled={true}
                    
                    />
                    <Form.Select
                      value={percent}
                      onChange={handlePercentChange}
                      variant="outline-secondary"
                      title="60%"
                      className="
                      percentageDropdown"
                      id="input-group-dropdown-2"
                      style={{maxWidth:"90px"}}
                      align="end"
                    >
                    {percentage.map((option, index) => (
                      <option key={index} value={option}>
                        {option} %
                      </option>
                    ))}
                    </Form.Select>
                  </InputGroup>
                </Col>

                <Col lg={6} className="mt-4">
                  <Form.Label>Token Liquidity</Form.Label>
                   <Form.Control
                    type="number"
                    name="liquidityValue"
                    placeholder="value"
                    value={liqForm.liquidityValue}
                    onChange={handleInputChange}
                    isInvalid={!!errors.liquidityValue}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.liquidityValue}
                  </Form.Control.Feedback>
                </Col>
                
                <Col lg={6} className="mt-4">
                    {chainId === '0x38' ? (
                      <Form.Label>Token Price(IN USDT(upto 18 decimals))*</Form.Label>) : (
                        <Form.Label>Token Price(IN USDT(upto 6 decimals))*</Form.Label>
                      )}
                   <Form.Control
                    type="number"
                    name="tokenPrice"
                    placeholder="value"
                    value={tokenPriceSwap}
                    isInvalid={!!errors.tokenPrice}
                    disabled
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenPrice}
                  </Form.Control.Feedback>
                </Col> 

              <Row className="mt-4">
                <Col lg={12}>
                  <Form.Label>Whitepaper</Form.Label>
                  <Form.Control
                    type="text"
                    name="whitepaper"
                    placeholder="Add a whitepaper link here."
                    value={form[0].whitepaper}
                    onChange={handleInputChange}
                    disabled={!update?true:false}

                  />
                </Col>
              </Row>
              <div className="mt-5">
                              <h6>
                                IMPORTANT: Special Liquidity Management SpecialLM - must agree *
                              </h6>
                              <p>
                                (Here is the description for the project owners, what they
                                have to agree upon prior to listing their project. This will
                                be a contract between INFI CDEX and the starting project that
                                needs to be <b>AGREE</b> and <b>CONFIRM</b> by the project
                                owner)
                              </p>
                            </div>
              
                            <div className="d-flex align-items-baseline">
                              <Form.Check
                                className="me-2"
                                checked={liqForm.agree}
                                onChange={handleCheckboxChange}
                                isInvalid={!!errors.agree}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.agree}
                              </Form.Control.Feedback>
                              <span>
                                Project owners must lock liquidity for a minimum of six
                                months, during which the liquidity remains inaccessible.
                                Safeguards are in place for companies to investigate and halt
                                trading if a scam or suspicious transaction is spotted. In
                                case of a confirmed scam, investors take precedence, impacting
                                the locked liquidity. Post the lock period, project owners
                                need approval from INFI ADMIN to access the liquidity, and
                                must justify their request
                              </span>
                            </div>
              
              <hr />

              <div className="mt-4 text-center">
              <Button variant="dark" className="px-4 py-2"onClick={(e)=>handleSubmitPool(e)} >
                  Create Pool
                </Button>
                {/* <Button variant="dark" className="px-4 me-2 py-2"onClick={e=>{handleSubmitPresale(e)}} >
                  Deploy Project
                </Button> */}
                {/* <Button variant="dark" className="px-4 py-2"onClick={()=>setUpdate(true)} >
                  Update
                </Button> */}
                <p className="mt-2">
                  Never submit password or credit card details through workform
                </p>
              </div>
            </div>
          </Form>}
        </Container>
      </section>
      <Footer />
    </>
  );
}
